/**
 * WhitelistStatusBadge — status weryfikacji konta bankowego kontrahenta na
 * białej liście podatników VAT MF.
 *
 * Wyodrębnione ze `renderCellValue` w `BankAccountsDynamicTab.tsx` (dead branch
 * `field.slug === 'whitelist_status'` usunięty — kolumna statusu jest teraz
 * FIXED, poza pętlą `listColumns`, na wzór kolumny akcji) i reużywane w
 * `WhitelistSyncModal.tsx` (lista istniejących kont w podglądzie synchronizacji).
 *
 * `WhitelistStatus` = frozen kontrakt backendu (5 stanów łącznie z `null`):
 *  - `active` — rachunek widoczny na białej liście dla NIP-u kontrahenta.
 *  - `not_found` — rachunek NIE widnieje na białej liście.
 *  - `virtual_unverified` — rachunek wirtualny (submasked), MF go nie
 *    publikuje wprost — wymaga ręcznej weryfikacji.
 *  - `not_applicable` — kontrahent bez NIP / nie-podatnik — check nie dotyczy.
 *  - `null` — jeszcze nie sprawdzono (nigdy nie wołano weryfikacji).
 */

import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/Badge';

export type WhitelistStatus = 'active' | 'not_found' | 'virtual_unverified' | 'not_applicable';

export function WhitelistStatusBadge({
  status,
}: {
  status: WhitelistStatus | null;
}): React.ReactElement {
  const { t } = useTranslation();

  switch (status) {
    case 'active':
      return <Badge color="green">{t('tenant.contractors.bankAccounts.whitelist.active')}</Badge>;
    case 'not_found':
      return <Badge color="red">{t('tenant.contractors.bankAccounts.whitelist.notFound')}</Badge>;
    case 'virtual_unverified':
      return (
        <Badge color="amber">
          {t('tenant.contractors.bankAccounts.whitelist.virtualUnverified')}
        </Badge>
      );
    case 'not_applicable':
      return (
        <Badge color="gray">{t('tenant.contractors.bankAccounts.whitelist.notApplicable')}</Badge>
      );
    case null:
    default:
      return <Badge color="gray">{t('tenant.contractors.bankAccounts.whitelist.unchecked')}</Badge>;
  }
}
